import React, { useContext } from 'react';
import { field } from '../../../types/Field';
import VariableSearchField from './VariableSearchField';
import SearchDataContext from '../../../providers/searchData-context';

const VariableSearchFields: React.FC = () => {
    const searchDataCtx = useContext(SearchDataContext);

    if (!searchDataCtx.format || !searchDataCtx.searchBy) {
        return <></>;
    }

    const updateValue = (abbreviation: string, newValue: string) => {
        searchDataCtx.setFieldValue(abbreviation, newValue);
    };

    const fieldsList = searchDataCtx.fields?.map((field) => {
        const currentValue = field.value ?? '';
        return (
            <VariableSearchField
                key={field.abbreviation}
                field={field}
                currentValue={currentValue}
                setCurrentValue={updateValue}
            />
        );
    });

    return (
        <>
            <div className='row sidebar-texts row-pad'>{fieldsList}</div>
        </>
    );
};

export default VariableSearchFields;
